<script setup lang="ts">
import { ALERT_STATUS } from "~/common/interfaces/alert-status.enum";
import { useAlertStore } from "~/stores/alert";
import { useItemPrototypesStore } from "~/stores/item-prototypes";
import { useModalStore } from "~/stores/modal";

const { t } = useI18n();
const route = useRoute();
const alertStore = useAlertStore();
const { itemPrototypesConfirmDelete } = useModalStore();
const itemPrototypesStore = useItemPrototypesStore();

const submitItemDelete = async () => {
	await itemPrototypesStore.deleteById(itemPrototypesConfirmDelete.itemPrototype.id);

	itemPrototypesConfirmDelete.closeModal();

	if (route.name === "products-item-prototypes-prototype") {
		navigateTo("/products/item-prototypes");
	} else if (route.name === "products-item-prototypes") {
		itemPrototypesStore.getAll({}, itemPrototypesStore.recentGetAllQuery);
	}

	alertStore.addAlert({
		title: t("COMPONENTS.ITEM_PROTOTYPES.CONFIRM_DELETE.alert.title"),
		description: t("COMPONENTS.ITEM_PROTOTYPES.CONFIRM_DELETE.alert.description", { itemPrototypeName: itemPrototypesConfirmDelete.itemPrototype.name.name }),
		status: ALERT_STATUS.SUCCESS
	});
};
</script>

<template>
	<AppModalConfirm
		:title="$t('COMPONENTS.ITEM_PROTOTYPES.CONFIRM_DELETE.title')"
		:description="$t('COMPONENTS.ITEM_PROTOTYPES.CONFIRM_DELETE.description', {itemPrototypeName: itemPrototypesConfirmDelete.itemPrototype.name.name})"
		:close-button-text="$t('COMMON.noCancel')"
		:submit-button-text="$t('COMMON.yesDelete')"
		@close="itemPrototypesConfirmDelete.closeModal"
		@submit="submitItemDelete"
	/>
</template>
